const DefaultLocalApiPort = "44372";
const ApiPath = "/secretaryapi";

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

function getConfiguredLocalApiPort(): string {
  const configuredPort = process.env.REACT_APP_API_PORT?.trim();
  const resolvedPort = configuredPort || DefaultLocalApiPort;

  if (!/^\d+$/.test(resolvedPort)) {
    throw new Error(`Invalid REACT_APP_API_PORT "${resolvedPort}". Expected a numeric port.`);
  }

  return resolvedPort;
}

function getLocalApiOrigin(): string {
  if (process.env.NODE_ENV !== "development" || typeof window === "undefined") {
    return "http://localhost";
  }

  const host = window.location.hostname?.trim();
  if (!host || host === "0.0.0.0") {
    return "http://localhost";
  }

  return `http://${host}`;
}

function resolveApiBaseUrl(): string {
  const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

  if (configuredBaseUrl) {
    return trimTrailingSlash(configuredBaseUrl);
  }

  return `${getLocalApiOrigin()}:${getConfiguredLocalApiPort()}${ApiPath}`;
}

export const apiBaseUrl = resolveApiBaseUrl();
export const apiHubUrl = `${apiBaseUrl}/hubs/calls`;
